var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistImagePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8466 3.8172C14.1564 3.50739 14.5766 3.33334 15.0147 3.33334C15.2317 3.33334 15.4465 3.37607 15.6469 3.45909C15.8473 3.54211 16.0294 3.6638 16.1829 3.8172C16.3363 3.9706 16.4579 4.15272 16.541 4.35314C16.624 4.55357 16.6667 4.76839 16.6667 4.98533C16.6667 5.20228 16.624 5.4171 16.541 5.61752C16.4579 5.81795 16.3363 6.00007 16.1829 6.15347L7.10126 15.2351C6.67406 15.6623 6.13879 15.9653 5.55269 16.1118L3.33337 16.6667L3.8882 14.4474C4.03473 13.8613 4.33779 13.326 4.76499 12.8988L13.8466 3.8172Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83334L14.1667 8.33334",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 16.6667L16.6667 16.6667",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistImagePencil);
export default __webpack_public_path__ + "static/media/artistImage-pencil.5a0c8de90f2ed353d2a798e69e3d99da.svg";
export { ForwardRef as ReactComponent };